class ProductDetailsSpecifications extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setupTooltips();
  }

  setupTooltips() {
    const tooltipTriggers = this.querySelectorAll(".comparison-table__tooltip-trigger");
    tooltipTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        const tooltip = trigger.nextElementSibling;
        const isVisible = tooltip.getAttribute("aria-hidden") === "false";

        // Hide all tooltips
        this.querySelectorAll(".comparison-table__custom-tooltip").forEach((t) => {
          t.setAttribute("aria-hidden", "true");
          t.style.opacity = "0";
          t.style.visibility = "hidden";
        });

        // Toggle the clicked tooltip
        tooltip.setAttribute("aria-hidden", isVisible);
        tooltip.style.opacity = isVisible ? "0" : "1";
        tooltip.style.visibility = isVisible ? "hidden" : "visible";
      });
    });

    // Close tooltip when clicking outside
    document.addEventListener("click", (event) => {
      if (!event.target.matches(".comparison-table__tooltip-trigger")) {
        this.querySelectorAll(".comparison-table__custom-tooltip").forEach((t) => {
          t.setAttribute("aria-hidden", "true");
          t.style.opacity = "0";
          t.style.visibility = "hidden";
        });
      }
    });

    document.querySelectorAll(".comparison-table__tooltip-trigger").forEach((trigger) => {
      trigger.addEventListener("mouseenter", handleTooltipPosition);
      trigger.addEventListener("focus", handleTooltipPosition);
    });

    function handleTooltipPosition(event) {
      const tooltip = event.target.nextElementSibling;
      if (!tooltip) return;

      // Reset classes
      tooltip.classList.remove("comparison-table__custom-tooltip--right", "comparison-table__custom-tooltip--left");

      // Get tooltip dimensions and position
      const tooltipRect = tooltip.getBoundingClientRect();
      const triggerRect = event.target.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      // Check if tooltip would overflow right side
      if (triggerRect.left + tooltipRect.width / 2 > viewportWidth - 20) {
        tooltip.classList.add("comparison-table__custom-tooltip--right");
      }
      // Check if tooltip would overflow left side
      else if (triggerRect.left - tooltipRect.width / 2 < 20) {
        tooltip.classList.add("comparison-table__custom-tooltip--left");
      }
    }

    // Add resize handler to reposition tooltips if needed
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const visibleTooltip = document.querySelector(
          '.comparison-table__custom-tooltip[style*="visibility: visible"]'
        );
        if (visibleTooltip) {
          const trigger = visibleTooltip.previousElementSibling;
          if (trigger) {
            handleTooltipPosition({ target: trigger });
          }
        }
      }, 100);
    });
  }
}

customElements.define("product-details-specifications", ProductDetailsSpecifications);